import Vue from "vue";
import Router from "vue-router";

// 引入页面组件

Vue.use(Router);

const router = new Router({
  mode: "history", // 使用 HTML5 History 模式（地址栏不会有 #）
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 };  
  },
  routes: [
    {
      path: "/",
      component: () => import("@/views/index.vue"),
      redirect: "/home",
      children: [
        {
          path: "home",
          name: "Home",
          component: () => import("@/views/home.vue"),
        },
        {
          path: "product/wulian",
          name: "wulian",
          component: () => import("@/views/productWulian.vue"),
        },
        {
          path: "product/shuju",
          name: "shuju",
          component: () => import("@/views/productShuju.vue"),
        },
        {
          path: "product/ddm",
          name: "ddm",
          component: () => import("@/views/productDidaima.vue"),
        },
        {
          path: "product/mes",
          name: "mes",
          component: () => import("@/views/productMes.vue"),
        },
        {
          path: "product/erp",
          name: "erp",
          component: () => import("@/views/productErp.vue"),
        },
        {
          path: "solution/jiaotong",
          name: "soluJiaotong",
          component: () => import("@/views/solu-jiaotong.vue"),
        },
        {
          path: "solution/jianzhu",
          name: "soluJianzhu",
          component: () => import("@/views/solu-jianzhu.vue"),
        },
        {
          path: "solution/shuili",
          name: "soluShuili",
          component: () => import("@/views/solu-shuili.vue"),
        },
        {
          path: "solution/shizhen",
          name: "soluShizhen",
          component: () => import("@/views/solu-shizheng.vue"),
        },
        {
          path: "solution/xiaoyuan",
          name: "soluXiaoyuan",
          component: () => import("@/views/solu-xiaoyuan.vue"),
        },
        {
          path: "solution/shequ",
          name: "soluShequ",
          component: () => import("@/views/solu-shequ.vue"),
        },
        {
          path: "solution/jiudian",
          name: "soluJiudian",
          component: () => import("@/views/solu-jiudian.vue"),
        },{
          path: "solution/anli",
          name: "soluAnli",
          component: () => import("@/views/solu-anli.vue"),
        },
        {
          path: "business",
          name: "Business",
          component: () => import("@/views/business.vue"),
        },
        {
          path: "ecological",
          name: "Ecological",
          component: () => import("@/views/ecological.vue"),
        },
        {
          path: "us",
          name: "Us",
          component: () => import("@/views/us.vue"),
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
    // 当前路径已是目标路径，阻止导航，避免报错
    next(false);
  } else {
    next();
  }
});
export default router;
